export const experienceData = [
    {
        id: 1,
        company: 'iSovix Technology LTD.',
        jobtitle: 'MERN Stack Developer',
        startYear: 'Jan 2022',
        endYear: 'Present'
    },
    {
        id: 2,
        company: 'Apstac Technology',
        jobtitle: 'Junior Web Developer (Wordpress)',
        startYear: 'Feb 2021',
        endYear: 'Dec 2021'
    },
    // {
    //     id: 3,
    //     company: 'Learning New Technology For Everyday',
    //     jobtitle: 'Self Learning',
    //     startYear: '2019',
    //     endYear: 'Present'
    // },
]